import * as React from 'react';

import { cn } from '@/shadcn/lib/utils';

type CustomProps = {
  invalid?: boolean;
};

const FakeInput = React.forwardRef<
  HTMLInputElement,
  CustomProps & React.ComponentProps<'input'>
>(({ className, type, invalid, disabled, ...props }, ref) => (
  <div
    aria-disabled={disabled}
    aria-invalid={invalid}
    className={cn(
      'flex h-10 w-full rounded-md border border-input bg-muted text-base ring-offset-background file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm placeholder:text-muted-foreground focus-within:outline-hidden focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 md:text-sm dark:bg-accent',
      invalid && 'border-destructive focus-within:ring-destructive/70',
      className
    )}
    ref={ref}
    {...props}
  />
));
FakeInput.displayName = 'Input';

const UnstyledInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'>
>(({ className, ...props }, ref) => (
  <input
    className={cn(
      'border-none placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    ref={ref}
    {...props}
  />
));
UnstyledInput.displayName = 'UnstyledInput';

export { FakeInput, UnstyledInput };
